import { DialogActions, DialogContent } from '@startuptools/ui/Dialog';
import { Dialog, DialogTitle } from '@startuptools/ui/Dialog';
import { Input } from '@startuptools/ui/Input';
import { Button } from '@startuptools/ui/joy/Button';
import { FormControl } from '@startuptools/ui/joy/FormControl';
import { FormLabel } from '@startuptools/ui/joy/FormLabel';
import { Controller, useForm } from 'react-hook-form';
import { toast } from '@startuptools/ui/toast/use-toast';
import { type GqlCreateAgreementMutationVariables, useCreateAgreementMutation } from './file-view.graphql';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { Trans } from '@lingui/react';
import { DocumentPreview } from './components/document-preview';
import { type GqlDocumentTemplate } from '../../../graphql/base-types.graphql';
import { Skeleton } from '@startuptools/ui/Skeleton';
import { useNavigate } from '../../../components/Navigate';

export const CreateAgreement = ({
  close,
  template,
}: {
  close: () => void;
  template: Pick<GqlDocumentTemplate, 'latestRevisionId' | 'name'>;
}) => {
  // eslint-disable-next-line sut/loading-mutation
  const [createAgreement] = useCreateAgreementMutation();
  const { navigate } = useNavigate();

  const companyId = useCompanyId();
  const form = useForm<GqlCreateAgreementMutationVariables>({
    defaultValues: {
      templateRevisionId: template.latestRevisionId,
      companyId,
      name: '',
    },
  });
  const onSubmit = async (data: GqlCreateAgreementMutationVariables) => {
    const res = await createAgreement({
      variables: data,
    });
    if (res.data?.createAgreement.file?.id) {
      await navigate(`/documents/company-documents/${res.data.createAgreement.file.id}`);
    } else {
      toast({
        title: <Trans id="Error" />,
        description: <Trans id="Failed to create agreement" />,
        severity: 'warning',
      });
    }
  };
  return (
    <Dialog open onClose={close}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <DialogTitle onClose={close}>
          <Trans id="Create Agreement" />
        </DialogTitle>
        <DialogContent>
          <DocumentPreview name={template.name} sx={{ width: 'auto', p: 4 }}>
            <Skeleton variant="text" level="body-sm" animation={false} />
            <Skeleton variant="text" level="body-sm" animation={false} />
            <Skeleton variant="text" level="body-sm" animation={false} />
          </DocumentPreview>

          <Controller
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormControl>
                <FormLabel>
                  <Trans id="Name" />
                </FormLabel>
                <Input {...field} />
              </FormControl>
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={close}>
            <Trans id="Cancel" />
          </Button>
          <Button type="submit">
            <Trans id="Create" />
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
